// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_EzYeB){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_6Zvhh .dualColumn_19GM8{display:flex;align-content:space-between}.nsAddressForm_6Zvhh .dualColumn_19GM8 .firstCol_3tK4A{margin-right:20px}.optional_3lXL5{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_EzYeB",
	"nsAddressForm": "nsAddressForm_6Zvhh",
	"dualColumn": "dualColumn_19GM8",
	"firstCol": "firstCol_3tK4A",
	"optional": "optional_3lXL5"
};
module.exports = exports;
